import { Component, DestroyRef, OnInit, inject, viewChild } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenavModule, MatSidenav } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ThemeToggle } from '../../components/theme-toggle/theme-toggle';
import { AuthService } from '../../auth/services/auth.service';

interface NavItem {
  label: string;
  icon: string;
  route: string;
}

interface NavSection {
  label: string;
  items: NavItem[];
}

@Component({
  selector: 'app-navigation',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    ThemeToggle,
  ],
  templateUrl: './navigation.html',
  styleUrl: './navigation.css',
})
export class Navigation implements OnInit {
  private readonly sidenav = viewChild<MatSidenav>('sidenav');

  private readonly auth = inject(AuthService);
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly destroyRef = inject(DestroyRef);

  isHandset = false;

  /** The signed-in SuperAdmin's email, shown in the account menu. */
  readonly currentUserEmail = this.auth.getCurrentUserEmail();

  readonly overviewItems: NavItem[] = [{ label: 'Painel', icon: 'dashboard', route: '/painel' }];

  readonly plataformaItems: NavItem[] = [
    { label: 'Organizações', icon: 'business', route: '/organizacoes' },
    { label: 'Usuários', icon: 'group', route: '/usuarios' },
  ];

  readonly configItems: NavItem[] = [{ label: 'Parâmetros', icon: 'tune', route: '/parametros' }];

  /** Drives the sidenav: one @for instead of three near-identical blocks. */
  readonly navSections: NavSection[] = [
    { label: 'Visão Geral', items: this.overviewItems },
    { label: 'Plataforma', items: this.plataformaItems },
    { label: 'Configurações', items: this.configItems },
  ];

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.isHandset = result.matches;
        const sidenav = this.sidenav();
        if (!sidenav) return;

        if (result.matches) {
          sidenav.close();
        } else {
          sidenav.open();
        }
      });
  }

  logout(): void {
    this.auth.logout();
  }
}
